import { EventEmitter, Injectable } from "@angular/core";

@Injectable()
export class FormEventsService {

    ionSlideDidChange: EventEmitter<void> = new EventEmitter<void>();
    exitGroupBackwards: EventEmitter<void> = new EventEmitter<void>();
    exitGroupForwards: EventEmitter<void> = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/vas/pages/form/form-events.service.ts